import { useState, useCallback } from 'react';
import ReportsService from '@/services/reportsService';
import { toast } from 'react-hot-toast';

const useWaiterPerformance = (initialFilters = {}) => {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [branchSummary, setBranchSummary] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState({
    branchId: initialFilters.branchId ?? null,
    period: initialFilters.period ?? null,
    startDate: initialFilters.startDate ?? null,
    endDate: initialFilters.endDate ?? null,
    waiterId: initialFilters.waiterId ?? null,
    offset: initialFilters.offset ?? 0,
    limit: initialFilters.limit ?? 25,
  });

 const fetchWaiterPerformance = useCallback(async (overrideFilters) => {
   try {
     setLoading(true);
     setError(null);

     const finalFilters = overrideFilters ?? filters;

     const response =
       await ReportsService.getWaiterPerformance(finalFilters);

     console.log("🟢 Raw API Response:", response);

     const payload = response;

     console.log("📊 payload.data:", payload?.data);

     setData(Array.isArray(payload?.data) ? payload.data : []);

     setSummary(payload?.summary ?? null);
     setBranchSummary(payload?.branchSummary ?? []);

     setTotal(
       payload?.total ??
       payload?.summary?.totalWaiters ??
       (Array.isArray(payload?.data) ? payload?.data.length : 0)
     );

   } catch (err) {
     console.error(err);
     setError('Failed to load waiter performance');
     toast.error('Failed to load waiter performance');
   } finally {
     setLoading(false);
   }
 }, [filters]);


  return {
    data,
    summary,
    branchSummary,
    total,
    loading,
    error,
    filters,
    setFilters,
    fetchWaiterPerformance,
  };
};

export default useWaiterPerformance;
